import React from 'react';
import * as I18n from 'circe/I18n';

import FormControlLabel from 'pencil/FormControlLabel';
import Checkbox from 'pencil/Checkbox';
import { Typography, Grid } from 'pencil';
import Input from 'pencil/Input';
import InputLabel from 'pencil/InputLabel';
import MenuItem from 'pencil/MenuItem';
import FormControl from 'pencil/FormControl';
import ListItemText from 'pencil/ListItemText';
import Select from 'pencil/Select';
import { ACLs } from 'domain/constants';
import { withStyles } from 'pencil/styles';
import SelectField from 'circe/forms/fields/SelectField';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
// startCase
const styles = {
  formControl: {
    padding: 20,
  },
  controlLabel: {
    marginLeft: 20,
    marginTop: 20,
  },
};

class TableProperities extends React.Component {
  render() {
    const { fields = [], classes } = this.props;
    return (
      <>
        <Typography variant="h6">{I18n.str('properties', 'Properties')}</Typography>
        <Grid container spacing={40}>
          <Grid xs={4}>
            <SelectField
              label={I18n.str('sortBy', 'Sort By')}
              fullWidth
              MenuProps={MenuProps}
              name="sortBy"
              className={classes.formControl}
              options={[
                {
                  label: 10,
                  value: 10,
                },
                {
                  label: 25,
                  value: 25,
                },
                {
                  label: 50,
                  value: 50,
                },
                {
                  label: 100,
                  value: 100,
                },
              ]}
              classes={{
                formControl: classes.formControl,
                label: classes.controlLabel,
              }}
            />
          </Grid>
          <Grid xs={4}>
            <SelectField
              label={I18n.str('sortDir', 'Sort Direction')}
              fullWidth
              MenuProps={MenuProps}
              name="sortDirection"
              options={[
                {
                  label: I18n.str('asc', 'ASC'),
                  value: 'asc',
                },
                {
                  label: I18n.str('desc', 'DESC'),
                  value: 'desc',
                },
              ]}
              classes={{
                formControl: classes.formControl,
                label: classes.controlLabel,
              }}
            />
          </Grid>

          <Grid xs={4}>
            <SelectField
              label={I18n.str('perPage', 'Items Per Page')}
              fullWidth
              MenuProps={MenuProps}
              name="perPage"
              options={[
                {
                  label: 10,
                  value: 10,
                },
                {
                  label: 25,
                  value: 25,
                },
                {
                  label: 50,
                  value: 50,
                },
                {
                  label: 10,
                  value: 10,
                },
              ]}
              classes={{
                formControl: classes.formControl,
                label: classes.controlLabel,
              }}
            />
          </Grid>
        </Grid>
      </>
    );
  }
}

export default withStyles(styles)(TableProperities);
